import React from "react";
import "./styles.scss";
const PageNotFound = () => {
  return (
    <div className="container-not-found">
      <h1>404 Page Not Found</h1>
    </div>
  );
};

export default PageNotFound;
